import React from "react";
import { useProducts } from "@/hooks/useProducts";
import { CookieBuilder } from "@/components/CookieBuilder";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function CookieShop() {
  const { products, loading } = useProducts("cookie");
  const { settings } = useAuth();
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
      <div className="text-center max-w-2xl mx-auto mb-10">
        <p className="font-script text-gold text-3xl mb-1">Dare to Be Different</p>
        <h1 className="font-serif text-4xl sm:text-5xl font-black text-cream tracking-tight">Gourmet Cookies</h1>
        <p className="text-cream/60 mt-4">Extraordinary cookies, unforgettable moments. Tap any flavors below to build your pairs.</p>
      </div>
      {loading || !settings ? (
        <div className="flex justify-center py-20"><Loader2 className="animate-spin text-gold" size={40} /></div>
      ) : (
        <CookieBuilder
          cookies={products}
          promoLabel={settings.cookie_promo_label}
          pairPrice={settings.cookie_pair_price}
          pairSize={settings.cookie_pair_size}
          bundleProductId={products[0]?.id}
        />
      )}
    </div>
  );
}
